export default {
  icon_text: 'Encerrado',
  buttons: {
    ok: 'Ok',
  },
};
